import {
  SET_SECTOR_UI_FLAG,
  CLEAR_SECTORS,
  SET_SECTORS,
  SET_SECTOR_ITEM,
  EDIT_SECTOR,
  DELETE_SECTOR,
  SET_ACTIVE_SECTOR,
  SET_ALL_SECTORS,
} from './types';
import SectorsAPI from '../../../api/sectors';

export const actions = {
  get: async ({ commit }) => {
    commit(SET_SECTOR_UI_FLAG, { isFetching: true });
    try {
      const { data } = await SectorsAPI.get();
      commit(CLEAR_SECTORS);
      commit(SET_SECTORS, data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_SECTOR_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, sectorInfo) => {
    commit(SET_SECTOR_UI_FLAG, { isCreating: true });
    try {
      const response = await SectorsAPI.create(sectorInfo);
      commit(SET_SECTOR_ITEM, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_SECTOR_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...updateObj }) => {
    commit(SET_SECTOR_UI_FLAG, { isUpdating: true });
    try {
      const response = await SectorsAPI.update(id, updateObj);
      commit(EDIT_SECTOR, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_SECTOR_UI_FLAG, { isUpdating: false });
    }
  },

  setActiveSector: ({ commit }, sectorId) => {
    commit(SET_ACTIVE_SECTOR, sectorId);
  },

  revalidate: async ({ commit }, _params = {}) => {
    try {
      const { data } = await SectorsAPI.get();
      commit(CLEAR_SECTORS);
      commit(SET_SECTORS, data);
    } catch (error) {
      // Ignore revalidation errors
    }
  },

  getAll: async ({ commit }) => {
    try {
      const { data } = await SectorsAPI.getAll();
      commit(SET_ALL_SECTORS, data);
    } catch (error) {
      // ignore
    }
  },

  delete: async ({ commit }, sectorId) => {
    commit(SET_SECTOR_UI_FLAG, { isDeleting: true });
    try {
      await SectorsAPI.delete(sectorId);
      commit(DELETE_SECTOR, sectorId);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_SECTOR_UI_FLAG, { isDeleting: false });
    }
  },
};
